import React from 'react';
import { createGridNormalRowRenderer } from '../../renderers/normalGridRow';
import { createGridNormalHeaderRenderer } from '../../renderers/normalGridHeader';
import { designTokens } from "../../../design/tokens";
import { GridLoadingOverlay } from "./GridLoadingOverlay";
import { GridEmptyBody } from "./GridEmptyBody";
import { GridDisabledOverlay } from "./GridDisabledOverlay";
import { styles } from './styles';
export function gridNormalPlugin(config) {
    var rowSize = designTokens.gridRowSize.getIntValue() || 32;
    var rootClassNames = [];
    var bodyAddons = [];
    var containerAddons = [];
    if (config === null || config === void 0 ? void 0 : config.isEmpty) {
        bodyAddons.push({
            id: 'empty',
            order: 0,
            render: function () {
                if (config.emptyRenderer) {
                    return config.emptyRenderer();
                }
                return React.createElement(GridEmptyBody, { text: 'No data' });
            }
        });
    }
    if (config === null || config === void 0 ? void 0 : config.isLoading) {
        bodyAddons.push({
            id: 'empty',
            order: 0,
            render: function () {
                return React.createElement(GridLoadingOverlay, null);
            }
        });
    }
    if (config === null || config === void 0 ? void 0 : config.disabled) {
        containerAddons.push({
            id: 'disabled-overlay',
            order: -9999,
            render: function () { return React.createElement(GridDisabledOverlay, null); }
        });
        rootClassNames.push(styles.rootDisabled);
    }
    return function () { return ({
        headerRenderer: (config === null || config === void 0 ? void 0 : config.headless) ? function () { return null; } : createGridNormalHeaderRenderer(),
        rowRenderer: createGridNormalRowRenderer({
            isRowInactive: config === null || config === void 0 ? void 0 : config.isRowInactive
        }),
        rowHeightGetter: (config === null || config === void 0 ? void 0 : config.rowHeightGetter) || (function () { return rowSize; }),
        containerAddons: containerAddons,
        bodyAddons: bodyAddons,
        rootClassNames: rootClassNames
    }); };
}
//# sourceMappingURL=gridNormalPlugin.js.map